export const SET_IS_AUTH = "SET_IS_AUTH";
export const SET_TOKEN = "SET_TOKEN";
export const LOGOUT = "LOGOUT";
export const FETCH_USER_LOADING = "FETCH_USER_LOADING";
export const FETCH_USER = "FETCH_USER";
export const SET_CHATBOT_VISIBILITY = "SET_CHATBOT_VISIBILITY";
